import type { Template } from "@/types";

export const SQ_03_H2_V1: Template[] = [
    {
        id: "sq-03-h2v1-01",
        name: "SQ 01 - H2V1",
        albumType: "SQ",
        thumbnail: "/thumbnails/SQ/sq-03-h2_v1_01.png",
        size: [1434, 717],
        style: {},
        slots: [
            { id: "1", x: 0, y: 160, width: 580, height: 400, rotation: 0, imageRotation: 0 },
            { id: "2", x: 588, y: 160, width: 264, height: 400, rotation: 0, imageRotation: 0 },
            { id: "3", x: 860, y: 160, width: 580, height: 400, rotation: 0, imageRotation: 0 },
        ],
    },

    {
        id: "sq-03-h2v1-02",
        name: "SQ 02 - H2V1",
        albumType: "SQ",
        thumbnail: "/thumbnails/SQ/sq-03-h2_v1_02.png",
        size: [1434, 717],
        style: {},
        slots: [
            { id: "1", x: 44, y: 175, width: 532, height: 365, rotation: 0, imageRotation: 0 },
            { id: "2", x: 584, y: 175, width: 266, height: 365, rotation: 0, imageRotation: 0 },
            { id: "3", x: 858, y: 175, width: 532, height: 365, rotation: 0, imageRotation: 0 },
        ],
    },

    {
        id: "sq-03-h2v1-03",
        name: "SQ 03 - H2V1",
        albumType: "SQ",
        thumbnail: "/thumbnails/SQ/sq-03-h2_v1_03.png",
        size: [1434, 717],
        style: {},
        slots: [
            { id: "1", x: 72, y: 82, width: 1022, height: 556, rotation: 0, imageRotation: 0 },
            { id: "2", x: 1102, y: 82, width: 267, height: 364, rotation: 0, imageRotation: 0 },
            { id: "3", x: 1102, y: 454, width: 267, height: 184, rotation: 0, imageRotation: 0 },
        ],
    },

    {
        id: "sq-03-h2v1-04",
        name: "SQ 04 - H2V1",
        albumType: "SQ",
        thumbnail: "/thumbnails/SQ/sq-03-h2_v1_04.png",
        size: [1434, 717],
        style: {},
        slots: [
            { id: "1", x: 0, y: 160, width: 580, height: 400, rotation: 0, imageRotation: 0 },
            { id: "2", x: 588, y: 160, width: 580, height: 400, rotation: 0, imageRotation: 0 },
            { id: "3", x: 1177, y: 160, width: 263, height: 400, rotation: 0, imageRotation: 0 },
        ],
    },
    {
        id: "sq-03-h2v1-05",
        name: "SQ 05 - H2V1",
        albumType: "SQ",
        thumbnail: "/thumbnails/SQ/sq-03-h2_v1_05.png",
        size: [1434, 717],
        style: {},
        slots: [        
            { id: "1", x: 309, y: 57, width: 405, height: 292, rotation: 0, imageRotation: 0 },
            { id: "2", x: 309, y: 357, width: 405, height: 291, rotation: 0, imageRotation: 0 },
            { id: "3", x: 722, y: 57, width: 404, height: 591, rotation: 0, imageRotation: 0 },
        ],
    },

    {
        id: "sq-03-h2v1-06",
        name: "SQ 06 - H2V1",
        albumType: "SQ",
        thumbnail: "/thumbnails/SQ/sq-03-h2_v1_06.png",
        size: [1434, 717],
        style: {},
        slots: [
            { id: "1", x: 161, y: 62, width: 393, height: 594, rotation: 0, imageRotation: 0 },
            { id: "2", x: 861, y: 62, width: 428, height: 293, rotation: 0, imageRotation: 0 },
            { id: "3", x: 861, y: 363, width: 428, height: 292, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "sq-03-h2v1-07",
        name: "SQ 07 - H2V1",
        albumType: "SQ",
        thumbnail: "/thumbnails/SQ/sq-03-h2_v1_07.png",
        size: [1434, 717],
        style: {},
        slots: [
            { id: "1", x: 62, y: 62, width: 391, height: 592, rotation: 0, imageRotation: 0 },
            { id: "2", x: 938, y: 63, width: 426, height: 291, rotation: 0, imageRotation: 0 },
            { id: "3", x: 938, y: 362, width: 426, height: 291, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "sq-03-h2v1-08",
        name: "SQ 08 - H2V1",
        albumType: "SQ",
        thumbnail: "/thumbnails/SQ/sq-03-h2_v1_08.png",
        size: [1434, 717],
        style: {},
        slots: [
            { id: "1", x: 197, y: 115, width: 323, height: 485, rotation: 0, imageRotation: 0 },
            { id: "2", x: 763, y: 253, width: 305, height: 209, rotation: 0, imageRotation: 0 },
            { id: "3", x: 1076, y: 253, width: 304, height: 209, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "sq-03-h2v1-09",
        name: "SQ 09 - H2V1",
        albumType: "SQ",
        thumbnail: "/thumbnails/SQ/sq-03-h2_v1_09.png",
        size: [1434, 717],
        style: {},
        slots: [
            { id: "1", x: 65, y: 110, width: 390, height: 496, rotation: 0, imageRotation: 0 },
            { id: "2", x: 944, y: 66, width: 419, height: 288, rotation: 0, imageRotation: 0 },
            { id: "3", x: 944, y: 362, width: 419, height: 288, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "sq-03-h2v1-10",
        name: "SQ 10 - H2V1",
        albumType: "SQ",
        thumbnail: "/thumbnails/SQ/sq-03-h2_v1_10.png",
        size: [1434, 717],
        style: {},
        slots: [    
            { id: "1", x: 136, y: 49, width: 444, height: 306, rotation: 0, imageRotation: 0 },
            { id: "2", x: 136, y: 363, width: 444, height: 306, rotation: 0, imageRotation: 0 },
            { id: "3", x: 869, y: 44, width: 413, height: 618, rotation: 0, imageRotation: 0 },
        ],
    },


];
